import { useApi } from '../services';

export const useSaveIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue`, 'POST', {}, {});

export const useGetBindIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/bind-option`, 'GET', {}, {});

export const useConfirmIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/confirm`, 'GET', {}, {});

export const useDeclineIssue = (idOperation) => useApi(`v2/operation/${idOperation}/issue/decline`, 'DELETE', {}, {});